/* istanbul ignore file */
import { highContrastFocus, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

import {
  FAVOURITE_ICON_TRANISITION_DURATION_IN_MS,
  FAVOURITE_TRANSITION_CLASSNAME,
} from './constants/favouriteButton';
import { baseButton } from '../Button/styles/base.styles';
import { spinnerTransitions } from '../Button/styles/spinner.styles';
import { BUTTON__CONTENT_CLASS } from 'client-ribbons-design-system';
import {
  FAVOURITE_LARGE_PRESS_SIZE,
  FAVOURITE_LARGE_SIZE,
  FAVOURITE_SMALL_PRESS_SIZE,
  FAVOURITE_SMALL_SIZE,
} from 'client-ribbons-design-system/styles/button';

const SPINNER_CLASSNAME_PREFIX = 'ribbons-outline-button';
const { fonts, responsiveText } = theme;

const outlineButtonStyles = css`
  ${baseButton}
  border-radius: ${pxToRem(6)};
  border: solid 1px ${palette.deepPurpleBase};
  background-color: transparent;

  .${BUTTON__CONTENT_CLASS} {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    height: ${pxToRem(28)};
    ${responsiveText.BODY.MD}
  }

  &:hover {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);
    border: solid ${pxToRem(1)} color-mix(in srgb, ${palette.deepPurpleBase} 20%, white);

    .${BUTTON__CONTENT_CLASS} {
      color: ${palette.deepPurpleBase};
    }
  }

  &.focus-visible:focus {
    background-color: var(--neutral-white-base);
  }

  &:disabled {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 10%, white);
    border: 1px solid color-mix(in srgb, ${palette.deepPurpleBase} 50%, white);
    cursor: not-allowed;

    .${BUTTON__CONTENT_CLASS} {
      color: ${palette.deepPurpleBase};
    }
  }

  ${spinnerTransitions(SPINNER_CLASSNAME_PREFIX)}
`;

export const small = css`
  width: ${pxToRem(FAVOURITE_SMALL_SIZE)};
  height: ${pxToRem(FAVOURITE_SMALL_SIZE)};
  background: var(--neutral-white-base);
  border: solid ${pxToRem(1)} var(--brand-purple-base) !important;

  &:active {
    transform: scale(${FAVOURITE_SMALL_PRESS_SIZE / FAVOURITE_SMALL_SIZE});
  }
`;

export const large = css`
  width: ${pxToRem(FAVOURITE_LARGE_SIZE)};
  height: ${pxToRem(FAVOURITE_LARGE_SIZE)};
  background: var(--neutral-white-base);
  border: solid ${pxToRem(1)} var(--brand-purple-base) !important;

  &:active {
    transform: scale(${FAVOURITE_LARGE_PRESS_SIZE / FAVOURITE_LARGE_SIZE});
  }

  &.focus-visible:focus {
    border: solid ${pxToRem(1)} var(--brand-purple-base) !important;
  }
`;

export const favouriteIconTransition = css`
  .${FAVOURITE_TRANSITION_CLASSNAME}-enter {
    opacity: 0;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
  .${FAVOURITE_TRANSITION_CLASSNAME}-exit {
    opacity: 1;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
  .${FAVOURITE_TRANSITION_CLASSNAME}-enter-active {
    opacity: 1;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
  .${FAVOURITE_TRANSITION_CLASSNAME}-exit-active {
    opacity: 0;
    transition: opacity ${FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}ms;
  }
`;

export const favouriteButton = css`
  ${outlineButtonStyles}
  cursor: pointer;
  position: absolute;
  border-radius: 50%;
  padding: 0;

  .${BUTTON__CONTENT_CLASS} {
    display: flex;
    justify-content: center;
  }

  &.focus-visible:focus {
    ${highContrastFocus}
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0;
    `,
  )};
`;
